/**
 * SK About Story - Reproductor de video inline
 * Click en play reemplaza thumbnail con iframe de YouTube/Vimeo
 */
(function () {
  'use strict';

  var playBtns = document.querySelectorAll('.sk-about-story__play-btn');

  for (var i = 0; i < playBtns.length; i++) {
    playBtns[i].addEventListener('click', handlePlay);
  }

  /**
   * Extrae ID y tipo de video de una URL de YouTube o Vimeo
   */
  function parseVideoUrl(url) {
    if (!url) return null;

    // YouTube: varios formatos
    var ytMatch = url.match(
      /(?:youtube\.com\/(?:watch\?v=|embed\/|v\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
    );
    if (ytMatch) {
      return { type: 'youtube', id: ytMatch[1] };
    }

    // Vimeo: varios formatos
    var vmMatch = url.match(
      /(?:vimeo\.com\/(?:video\/)?|player\.vimeo\.com\/video\/)(\d+)/
    );
    if (vmMatch) {
      return { type: 'vimeo', id: vmMatch[1] };
    }

    return null;
  }

  /**
   * Genera la URL del iframe segun el tipo de video
   */
  function getEmbedUrl(video) {
    if (video.type === 'youtube') {
      return 'https://www.youtube.com/embed/' + video.id + '?autoplay=1&rel=0';
    }
    if (video.type === 'vimeo') {
      return 'https://player.vimeo.com/video/' + video.id + '?autoplay=1';
    }
    return '';
  }

  /**
   * Maneja el click en el boton play
   */
  function handlePlay() {
    var wrap = this.closest('.sk-about-story__image-wrap');
    if (!wrap) return;

    var videoUrl = wrap.getAttribute('data-video-url');
    var video = parseVideoUrl(videoUrl);
    if (!video) return;

    var embedUrl = getEmbedUrl(video);
    if (!embedUrl) return;

    // Crear iframe con clase BEM
    var iframe = document.createElement('iframe');
    iframe.className = 'sk-about-story__iframe';
    iframe.setAttribute('src', embedUrl);
    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('title', 'Video sobre la historia y origen de SOKA');

    // Ocultar imagen/placeholder y boton, agregar iframe
    var img = wrap.querySelector('.sk-about-story__image, .sk-about-story__placeholder');
    if (img) img.style.display = 'none';
    this.style.display = 'none';
    wrap.appendChild(iframe);
  }
})();
